import React from 'react';
import { useIntl } from 'react-intl';
import { 
  LoaderContainer,
  SpinnerRing,
  LoadingText 
} from './styles';

const ModernLoader = ({ 
  size = 'medium', 
  showText = true, 
  text = null,
  color = '#002244'
}) => {
  const intl = useIntl();
  
  const displayText = text || intl.formatMessage({ id: 'modern_loader.loading' });

  return (
    <LoaderContainer>
      <SpinnerRing size={size} color={color} />
      {showText && (
        <LoadingText>
          {displayText}
        </LoadingText>
      )}
    </LoaderContainer>
  );
};

export default ModernLoader;